import {httpGet, httpPost} from "./http";

const commentUrl = window.env.BACKEND_API_URL + "/comments";

const getComments = async (page = 1, pageSize = 10, commentableType = null, commentableID = null, signal) => {
    let commentIndexUrl = `${commentUrl}/?page=${page}&per_page=${pageSize}`;

    if (commentableType && commentableID) {
        commentIndexUrl += `&commentable_type=${commentableType}&commentable_id=${commentableID}`;
    }

    return await httpGet(commentIndexUrl, signal);
};

const addComment = async ({commentableType, commentableID, text}, signal) => {
    const body = {
        commentable_type: commentableType,
        commentable_id: commentableID,
        text,
    };

    return await httpPost(commentUrl, body, signal);
};

export {getComments, addComment};
